import {api} from './Api';
import {DataRetention} from '../models';

export const updateDataRetention = (dataRetention: DataRetention) => {
  return api.post(`data_retention/update`, dataRetention).then((res: any) => res.data);
}
